import { ServiceData } from "../../lib/useServiceData"
import { Link } from "react-router-dom";
import ServiceBoxTitle from "./components/ServiceBoxTitle";
import { useTranslation } from 'react-i18next';
import ramadanImg from "../../assets/ramadan/DecorationBackground.jpg"
import { currentMonth } from "../../components/ramadan"

export default function AllServicesBox() {
    const { i18n } = useTranslation();

    return (
        <div className={`bg-dark-orange text-white py-4 mt-4 position-relative ${currentMonth === 9 ? 'bgOpacity10' : ''}`}>
            <div className="container d-flex flex-wrap gap-3 justify-content-start">
                <ServiceBoxTitle />
                {ServiceData.map((service, index) => (
                    <div key={index} className="col bg-white rounded px-4 py-2 text-black text-center">
                        <Link
                            className={`text-decoration-none text-black ${service.status}`}
                            to={`/${i18n.language}/${service.btnLink}`} >
                            <img className="serv-ico p-1 mt-1 mb-2" src={service.icon} alt={service.imgAlt} />
                            <h6>{i18n.language === "ar" ? service.title : service.titleEn}</h6>
                        </Link>
                    </div>
                ))}
            </div>
            <img src={ramadanImg} alt="ramadan" className="ramadan-img" />
        </div>
    )
}